/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.pages.forms.page.controllers', [
  'ui.bootstrap',
  'acme.common.service.posConfig',
  'acme.view.application.pos.create.pages.forms.page.modals.controllers'
])

.controller('PosCreatePagesFormsPageController', ['$scope', '$uibModal', '$timeout', 'PosConfigService', function($scope, $uibModal, $timeout, PosConfigService) {

    $scope.posCreatePagesFormsPage = {

      model: {
        id: '',
        pageNumber: '',
        pageHeader: '',
        description: ''
      },

      cache: {},
      removeModal: {},

      init: function() {
        $scope.$on('PosCreatePagesFormsController::UpdatePage', this.onPosCreatePagesFormsControllerUpdatePage);
      },

      canDelete: function() {
        return PosConfigService.pages.canDelete();
      },

      update: function() {
        this.cache = angular.copy(this.model);
        $scope.$emit('PosCreatePagesFormsPageController::UpdatePage', this.model);
      },

      cancel: function() {
        this.model = angular.copy(this.cache);
      },

      remove: function() {
        // TODO: Implement API Call for deleting a page after modal callback
        var self = $scope.posCreatePagesFormsPage,
            refs = PosConfigService.getReferencedNavigationTiles(this.model.pageId);

        this.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/pos/create/pages/forms/page/modals/deletePage.tpl.html',
          size: 'md',
          controller: 'PosCreatePagesFormsPageModalsController',
          resolve: {
            page: function() {
              return self.model;
            },
            allow: function() {
              return (PosConfigService.pages.getModel().length > 1);
            },
            items: function() {
              return refs;
            }
          }
        });

        this.removeModal.result.then(function (res) {
          if(res) {
            $scope.$emit('PosCreatePagesFormsPageController::RemovePage', self.model);
          }
        }, function() {
          // do nothing});
        });

      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onPosCreatePagesFormsControllerUpdatePage: function(e, data) {
        var self = $scope.posCreatePagesFormsPage;

        self.cache = angular.copy(data);
        self.model = data;
      }

    };

    $scope.posCreatePagesFormsPage.init();

}]);